import React from 'react'
import { Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core'

import MapCard from './MapCard'
import MapPriceTag from './MapPriceTag'

const styles = {
  circle: {
    position: 'absolute',
    display: 'inline-block',
    margin: 0,
    padding: 0,
    borderRadius: '50%',
    background: '#00bcb5',
    zIndex: 'inherit',
  },
}

const MapMarker = props => {
  const { hovered, property, linkTo, showPriceTag, classes } = props
  const cw = 10
  const orgX = cw * 0.5
  const orgY = cw

  const circle = (
    <Link
      to={linkTo}
      onClick={() => props.onMarkerClick()}
      className={classes.circle}
      style={{
        width: cw,
        height: cw,
        top: -orgY,
        left: -orgX,
        transformOrigin: `${orgX} ${orgY}`,
        border: hovered ? '2px solid #ffffff' : '2px solid #009e99',
        boxShadow: hovered ? '0 0 0 8px rgba(29, 187, 176, 0.3)' : 'none',
      }}
    />
  )

  if (hovered) {
    return (
      <div>
        {circle}
        <MapCard property={property} />
        {showPriceTag && <MapPriceTag price={property.price} hovered={hovered} linkTo={linkTo} />}
      </div>
    )
  } else {
    return (
      <div>
        {circle}
        {showPriceTag && <MapPriceTag price={property.price} hovered={hovered} linkTo={linkTo} />}
      </div>
    )
  }
}

MapMarker.defaultProps = {
  cw: 14,
}

export default withStyles(styles)(MapMarker)



// WEBPACK FOOTER //
// ./src/components/map/MapMarker.js